import dayjs from 'dayjs'
import Big from 'big.js'
import {
  formatFerries,
  formatAttraction,
  formatAccommodation,
} from './reducePostCartResponse'
import { cancelledCodes } from '../../config/itineraryStatusCodes'

const reduceBookingViewResponse = (data, config) => {
  const ferryItem = data?.itineraryInfo?.reservationItems?.find(
    item => !!item.ferry,
  )
  const amendableFields = ferryItem?.ferry?.amendableFields
  const bookingNumber = ferryItem?.bookingReference
  const status = data?.status
  const startDate = data?.startDate?.split('T')?.[0]
  const endDate = data?.endDate?.split('T')?.[0]
  const numberOfGuests = data?.numberOfGuests
  const grandTotal =
    data?.travelCost?.costTotals?.amountAfterTax ||
    data?.itineraryPricing?.[0]?.cost?.amountAfterTax

  const landBasedResources = ferryItem?.ferry?.landBasedResources
  const accommodations = landBasedResources?.accommodations

  const formattedItems = {
    customerInfos: data?.customerInfos,
    ferries: [],
    hotels: [],
    attractions: [],
    donations: [],
    accommodations: [],
  }

  data?.itineraryInfo?.reservationItems.forEach(item => {
    if (item.ferry) {
      if (item.ferry.departures.length > 0) {
        const formattedFerry = formatFerries(item, config)
        formattedItems.ferries.push(formattedFerry)
      }

      if (item.ferry.landBasedResources?.attractions.length > 0) {
        item.ferry.landBasedResources.attractions.forEach(attraction => {
          formattedItems.attractions.push(formatAttraction(attraction))
        })
      }
      if (item.ferry.landBasedResources?.sundries.length > 0) {
        item.ferry.landBasedResources.sundries.forEach(donation => {
          formattedItems.donations.push(formatAttraction(donation))
        })
      }
      if (
        item.ferry.landBasedResources?.accommodations?.length > 0 &&
        !data?.itineraryInfo?.reservationItems.some(value => value.hotel)
      ) {
        item.ferry.landBasedResources?.accommodations.forEach(accommodation => {
          formattedItems.accommodations.push(accommodation)
        })
      }
    }
    if (item.hotel) {
      const formattedHotel = formatAccommodation(item)
      const selectedAccommodation = accommodations.find(
        accommodation =>
          accommodation.resourceCode === formattedHotel.resourceCode,
      )
      // https://verbinteractive.atlassian.net/browse/RED200-2136
      formattedItems.hotels.push({
        ...formattedHotel,
        price:
          selectedAccommodation?.price &&
          selectedAccommodation?.amount &&
          new Big(
            selectedAccommodation.price / selectedAccommodation.amount,
          ).toNumber(),
      })
    }
  })

  const currentTime = dayjs().tz().toDate().getTime()
  const startTime = dayjs.tz(startDate).toDate().getTime()
  const isPast = currentTime > startTime
  const outwardHasDeparted = currentTime > startTime
  const returnHasDeparted = currentTime > dayjs.tz(endDate).toDate().getTime()

  const isItineraryCancellable =
    data?.isCancellable && data?.status && +data.status === 30
  const isItineraryCancelled =
    !data?.status ||
    cancelledCodes.some(code => data?.status && code === +data.status)

  const isFerryCancelled =
    ferryItem?.status && cancelledCodes.some(code => code === +ferryItem.status)

  const hasCrossings = !!ferryItem?.ferry?.departures?.length

  return {
    ...data,
    startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
    endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
    numberOfGuests,
    guestCount: numberOfGuests && +numberOfGuests ? +numberOfGuests : 1,
    status,
    isItineraryCancellable,
    isItineraryCancelled,
    isFerryCancelled,
    ...formattedItems,
    bookingNumber,
    grandTotal,
    isPast,
    outwardHasDeparted,
    returnHasDeparted,
    hasCrossings,
    totalCost: ferryItem?.ferry?.reservationTotals?.price,
    ferryProductCode: ferryItem?.ferry?.productCode,
    amendableFields,
  }
}

export default reduceBookingViewResponse
